import React, { useMemo } from 'react';
import { PromoPod } from '../promo-pod/PromoPod';
import { usePromoPresentation } from '../../contexts/PromoPresentationProvider';
import { usePromoCart } from '../../contexts/PromoCartProvider';
import { usePromoModel } from '../../contexts/PromoModelProvider';
import './PromoList.scss';

export const PromoList = () => {
  const { setPromoListRef } = usePromoPresentation();
  const { bogoSelectedProduct, freeItemInCart } = usePromoCart();
  const { allItemIds, anchorItemId, isBogo } = usePromoModel();
  const toBeSelected = bogoSelectedProduct || freeItemInCart;

  const itemIdsToDisplay = useMemo(() => {
    if (isBogo) {
      const withoutAnchor = allItemIds.filter((itemId) => {
        return itemId !== anchorItemId;
      });
      return withoutAnchor;
    }
    return allItemIds;
  }, [isBogo, allItemIds, anchorItemId]);

  return (
    <article
      className="promo-list"
      data-testid="promo-list"
      ref={setPromoListRef}
    >
      { itemIdsToDisplay.map((itemId, i) => {
        return (
          <PromoPod
            key={itemId}
            itemId={itemId}
            selected={isBogo ? toBeSelected?.itemId === itemId : false}
            displayPosition={String(i + 1)}
          />
        );
      })}
    </article>
  );
};

PromoList.displayName = 'PromoList';
